import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mc-fix-alert z-2002"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "me-4"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-15"
}, [/*#__PURE__*/_createTextVNode(" Some of our clients are currently experiencing difficulties - accessing certain features."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Our team is actively working to resolve the issue as quickly as possible. ")])])], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true"
}, "×", -1);
const _hoisted_4 = [_hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  return $data.show && $data.maintanace != $data.version ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_row, {
    "align-v": "center"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("button", {
    type: "button",
    class: "close",
    "aria-label": "Close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }, _hoisted_4)])) : _createCommentVNode("", true);
}